import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import HomePage from "../pages/home/page";
import DashboardPage from "../pages/dashboard/page";
import ActivitiesPage from "../pages/activities/page";
import CalendarPage from "../pages/calendar/page";
import AnalyticsPage from "../pages/analytics/page";
import ActivityAssetsPage from "../pages/activity-assets/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <HomePage />,
  },
  {
    path: "/dashboard",
    element: <DashboardPage />,
  },
  {
    path: "/activities",
    element: <ActivitiesPage />,
  },
  {
    path: "/activity-assets",
    element: <ActivityAssetsPage />,
  },
  {
    path: "/calendar",
    element: <CalendarPage />,
  },
  {
    path: "/analytics",
    element: <AnalyticsPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
